import { useEffect, useState } from "react"
import { defaultCardSelection, GroupHeader, groupSelector, handleMultiple, mainHeader, multipleAnswerForm, selectHeader, singleAnswerForm } from "./functions"

const preFinishOpt = [
  "Contrapiso comum",
  "Contrapiso acústico",
  "Contrapiso autonivelante",
  "Regularização (exceto impermeabilização)",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
]

const finishOpt = [
  "Pedra",
  "Porcelanato",
  "Peça Cerâmica",
  "Pastilha",
  "Cimentado",
  "Polimento",
  "Lapidação",
  "Madeira",
  "Pintura",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "Concreto Estampado",
  "Grama",
  "Concregrama",
  "Sem Acabamento",
  "Emborrachado",
  "Vinílico",
  "Outro",
  "Seguir Descrição do Projeto",
  "Definir Posteriormente"
]

const fillerOpt = ["Piso elevado", "EPS", "Concreto leve", "Argila Expandida", "Outro", "Definir Posteriormente"]

const FloorQuestions = ({ onGroupsChange, formData, preGroup, finished }) => {
  const [groups, setGroups] = useState([])
  const [currentGroup, setCurrentGroup] = useState([])
  const [formatPav, setFormatPav] = useState([])
  const [toggle, setToggle] = useState(true)
  const { floors } = formData.roomDefinitions
  const { pavements } = formData
  const [visibleGroups, setVisibleGroups] = useState([])

  const handleGroup = (e) => {
    if (finished) return;
    if (!currentGroup.includes(e)) {
      setCurrentGroup([...currentGroup, e])
    } else {
      setCurrentGroup(currentGroup.filter(i => i !== e))
    }
  }

  const finishGroup = () => {
    setGroups([...groups, { rooms: currentGroup.sort(), preFinish: [], finish: "" }])
    setCurrentGroup([])
  }

  useEffect(() => {
    onGroupsChange(groups)
  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const elem = document.getElementById(`pisos-${groups.length - 1}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [groups.length])

  useEffect(() => {
    const pavs = pavements.map(i => {
      return {
        pavement: i.pavement,
        rooms: i.rooms.filter(j => floors.includes(j))
      }
    })
    setFormatPav(pavs.filter(i => i.rooms.length > 0));
    setGroups(preGroup || [])
  }, [])

  const checkRemaining = (arr) => {
    const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
    return remaining;
  }

  const selectAll = () => {
    if (currentGroup.join('') === checkRemaining(floors).join('')) {
      setCurrentGroup([])
    } else {
      setCurrentGroup(checkRemaining(floors))
    }
  }

  const selectBulk = (priv) => {
    const privAreas = formData.roomDefinitions.privAreas.filter(i => formData.roomDefinitions.floors.includes(i));
    if (priv) {
      setCurrentGroup(privAreas);
    } else {
      const common = formData.rooms.filter(i => !privAreas.includes(i)).filter(i => formData.roomDefinitions.floors.includes(i))
      setCurrentGroup(common)
    }
  }

  const handleChanges = (e, idx, field) => {
    if (finished) return;
    const newGroups = [...groups];
    newGroups[idx][field] = e;
    setGroups(newGroups);
  }

  const resetGroup = (idx) => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    setCurrentGroup([]);
  }

  const resetAll = () => {
    setGroups([])
  }

  const handleMultipleChanges = (idx, field, type) => {
    handleMultiple(finished, groups, idx, field, type, { type, thickness: 0 }, setGroups);
  }

  const handleToggle = (idx) => {
    if (visibleGroups.includes(idx)) {
      setVisibleGroups(visibleGroups.filter(i => i !== idx))
    } else {
      setVisibleGroups([...visibleGroups, idx])
    }
  }

  return <div className="form-section">
    {mainHeader("Pisos", groups, resetAll, toggle, setToggle)}
    {toggle && <>
      {groups.length > 0 && <>
        {groups.map((i, idx) => {
          return <div id={`pisos-${idx}`} key={idx} className="margin-bottom-16">
            <GroupHeader remaining={checkRemaining(floors)} idx={idx} rooms={i.rooms} handleToggle={handleToggle} active={visibleGroups.includes(idx)} groups={groups} setGroups={setGroups} setCurrentGroup={setCurrentGroup} />
            {visibleGroups.includes(idx) && <div className="group-questions-container">

              {singleAnswerForm("Qual tipo de acabamento nesses ambientes?", finishOpt, idx, "finish", formData.projRoomFull, "Pisos", groups[idx], handleChanges, finished)}

              {!["Cimentado", "Polimento", "Lapidação"].includes(groups[idx].finish) &&
                <>
                  {multipleAnswerForm("Quais opções de pré-acabamentos serão utilizados no piso dos ambientes desse grupo?", preFinishOpt, idx, "preFinish", groups[idx], handleMultipleChanges, formData.projRoomFull, "Pisos", handleChanges, finished)}

                  {i.preFinish.some(j => preFinishOpt.slice(0, 5).includes(j.type)) && (
                    <div className="question-container">
                      <p className="margin-tier-1">Espessuras (cm):</p>
                      {i.preFinish.map((j, idx2) => {
                        if (!preFinishOpt.slice(0, 5).includes(j.type)) return null;
                        return <div key={idx2} className="margin-tier-2 margin-bottom-8">
                          <label>{j.type}</label>
                          <input type="number" placeholder="Espessura em cm" value={j.thickness} onChange={(e) => {
                            const newGroups = [...groups];
                            newGroups[idx].preFinish[idx2].thickness = e.target.value;
                            setGroups(newGroups);
                          }} />
                        </div>
                      })}
                    </div>
                  )}
                </>
              }

              {singleAnswerForm("Haverá enchimento abaixo do piso?", ["Sim", "Não"], idx, "hasFloorFiller", formData.projRoomFull, "Enchimento de piso", groups[idx], handleChanges, finished)}
              {groups[idx].hasFloorFiller === "Sim" && <>
                {singleAnswerForm("Qual material do enchimento?", fillerOpt, idx, "floorFillerMaterial", formData.projRoomFull, "Material do enchimento", groups[idx], handleChanges, finished)}
                <div className='question-container'>
                  <label>Qual espessura do enchimento? (cm)</label>
                  <input className="margin-tier-1" type='number' placeholder='Espessura em CM' value={groups[idx].thickness} onChange={(e) => handleChanges(e.target.value, idx, 'floorFillerThickness')} />
                </div>
              </>
              }
            </div>}

          </div>
        })}
      </>}

      {checkRemaining(floors).length > 0 && <>
        <label className="margin-tier-2 select-groups-header">Selecionar grupos</label>
        {selectHeader(selectAll, selectBulk)}
      </>}
      {groupSelector(formatPav, groups, currentGroup, handleGroup, finishGroup, floors)}
    </>}
  </div>
}

export default FloorQuestions;